const removeEmptyMakeFilter = (makes) => makes?.filter((make) => (make.count && make.count > 0)) || [];

export default removeEmptyMakeFilter;
